<template>
  <div ref="wrapper" class="youtube-embed__wrapper">
    <template v-if="isVisible">
      <div v-if="isLoading" aria-hidden="true" class="youtube-embed__loading">
        <div class="youtube-embed__spinner"></div>
      </div>
      <iframe
        :id="videoId"
        class="youtube-embed__iframe main-slide__youtube-embed"
        frameborder="0"
        allowfullscreen="yes"
        allow="
          accelerometer;
          autoplay;
          clipboard-write;
          encrypted-media;
          gyroscope;
          picture-in-picture;
          web-share;
        "
        referrerpolicy="strict-origin-when-cross-origin"
        :title="title || a11yLabels.video"
        width="100%"
        height="100%"
        :src="youtubeUrl"
        @load="isLoading = false"
        @error="isLoading = false"
      ></iframe>
    </template>
  </div>
</template>

<script>
export default {
  name: 'youtube-embed',
  inject: ['a11yLabels'],
  props: {
    videoId: {
      type: String,
      default: '',
    },
    muted: {
      type: Boolean,
      default: false,
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isVisible: false,
      isLoading: true,
    };
  },
  computed: {
    youtubeUrl() {
      const params = new URLSearchParams({
        autoplay: this.autoplay,
        mute: this.autoplay ? 1 : Number(this.muted),
        loop: 1,
        playsinline: 1,
        controls: 1,
        enablejsapi: 1,
        modestbranding: 1,
        rel: 0,
        showinfo: 0,
      });
      return `https://www.youtube.com/embed/${this.videoId}?${params}`;
    },
  },
  mounted() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.isVisible = true;
          this.observer.disconnect();
        }
      },
      { rootMargin: '300px 0px' },
    );
    this.observer.observe(this.$refs.wrapper);
  },
  beforeDestroy() {
    this.handleBeforeUnmount();
  },
  beforeUnmount() {
    this.handleBeforeUnmount();
  },
  methods: {
    handleBeforeUnmount() {
      if (this.observer) {
        this.observer.disconnect();
      }
    },
  },
};
</script>
